export const CLASSIFIED_EXTRA_ABBREVIATIONS = [
  'tv',
  'wc',
  'vat',
  'usb',
  'bss',
  'cd',
  'dvd',
  'ebs',
  'esp',
  'gps',
  'tcs',
  'asr',
  'vhf',
  'zsa',
  'tft',
  'abs',
  'led',
  'a/c'
]
